import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE from "../config/api";

const TrendingSearches = () => {
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [province, setProvince] = useState("");

    const FALLBACK_IMG = "/assets/defaultList.jpg";

    useEffect(() => {
        const prov = localStorage.getItem("dn_province") || "";
        setProvince(prov);

        fetch(`${API_BASE}/api/get_trending_searches.php?limit=6&province=${encodeURIComponent(prov)}`)
            .then((res) => res.json())
            .then((data) => {
                if (data.success && Array.isArray(data.data)) setItems(data.data);
            })
            .catch((err) => console.log(err))
            .finally(() => setLoading(false));
    }, []);

    const goToCategory = (title) => {
        const loc = localStorage.getItem("dn_province") || "";
        navigate(`/search?search=&location=${encodeURIComponent(loc)}&category=${encodeURIComponent(title)}`);
    };

    if (!loading && items.length === 0) return null;

    return (
        <div className="container my-5">
            <h2 className="fw-bold text-dark mb-1">
                Trending Searches {province ? `in ${province}` : "Near You"}
                <span className="badge bg-danger ms-2">NEW</span>
            </h2>
            <p className="text-muted mb-4">Stay updated with the latest local trends.</p>

            <div className="row g-3">
                {loading
                    ? Array.from({ length: 6 }).map((_, i) => (
                        <div key={i} className="col-6 col-md-4 col-lg-4">
                            <div className="border rounded shadow-sm bg-white" style={{ height: 178 }}>
                                <div style={{ height: 120, background: "#eef1f5" }}></div>
                                <div className="p-2">
                                    <div style={{ height: 14, width: "70%", background: "#eef1f5", borderRadius: 4 }}></div>
                                </div>
                            </div>
                        </div>
                    ))
                    : items.map((item, index) => (
                        <div key={index} className="col-6 col-md-4 col-lg-4">
                            <button
                                type="button"
                                onClick={() => goToCategory(item.title)}
                                className="text-decoration-none d-block border rounded shadow-sm bg-white w-100 p-0"
                                style={{ cursor: "pointer" }}
                            >
                                <div style={{ height: "120px", overflow: "hidden" }}>
                                    <img
                                        src={item.img || FALLBACK_IMG}
                                        alt={item.title}
                                        className="w-100 h-100"
                                        style={{ objectFit: "cover" }}
                                        onError={(e) => { e.target.onerror = null; e.target.src = FALLBACK_IMG; }}
                                    />
                                </div>
                                <div className="p-2 text-start">
                                    <h6 className="fw-bold text-dark mb-1" style={{ height: "40px", overflow: "hidden" }}>
                                        {item.title}
                                    </h6>
                                    <div className="text-primary fw-semibold small">Explore →</div>
                                </div>
                            </button>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default TrendingSearches;
